/** Layout the primitives' props cannot express. Colours use theme tokens. */

export const bulletListClassName = 'ml-5 list-disc';

/** Summary rows: label column, value, and the "Breyta" action. */
export const summaryRowColumns = '150px 1fr auto';

export const summaryRowClassName = 'border-border border-b';

export const logoIllustrationClassName = 'size-[220px]';

export const logoImageClassName = 'size-[120px]';
